import { typedKeys } from '../typedKeys';

export const omitProperties = <
  T extends Record<string, unknown>,
  G extends keyof T,
>(
  obj: T,
  ...properties: G[]
): Omit<T, G> => {
  return typedKeys(obj).reduce(
    (acc, key) => {
      if (properties.every((prop) => prop !== key)) {
        const typed = key as Exclude<keyof T, G>;
        acc[typed] = obj[typed];
      }
      return acc;
    },
    {} as Omit<T, G>,
  );
};
